// Shop Now prices are stored in J$; shoppers see US$ first with the J$ amount underneath (live BOJ-aligned rate from /api/fx).
let USD_RATE = 0.0064;
export const setFxRate = (r) => { if (r && Number.isFinite(Number(r)) && Number(r) > 0) USD_RATE = Number(r); };
export const getFxRate = () => USD_RATE;
export const usd = (n) => "US$" + (Number(n || 0) * USD_RATE).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const jmdOnly = (n) => "J$" + Number(n || 0).toLocaleString("en-JM", { maximumFractionDigits: 0 });
export const jmd = (n) => usd(n); // main price everywhere is US$; use <Price> to show the J$ line underneath
export const usdToJmd = (u) => Math.round(Number(u || 0) / USD_RATE);
